import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ContactFormFields } from '@spa/components/contact/contactFormTypes';
import { ContactState } from './ContactState';
import { SubmitContactFormResult } from '../../graphql/transactional-email/submitContactForm';
import { WithHoneypot } from '@spa/components/forms/formik-with-honey/formikWithHoney.component';

const initialState: ContactState = {
  pageActions: {
    submitForm: {
      pending: [],
      succeeded: [],
      failed: []
    }
  }
};

export interface SubmitContactFormRequestedPayload {
  readonly actionId: number;
  readonly formData: WithHoneypot<ContactFormFields>;
  readonly honeypotToken: string;
}

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    submitContactFormRequested(state, action: PayloadAction<SubmitContactFormRequestedPayload>) {
      state.pageActions.submitForm.pending.push(action.payload.actionId);
    },
    submitContactFormSucceeded(
      state,
      action: PayloadAction<{
        requestedActionId: number;
        result: SubmitContactFormResult;
      }>
    ) {
      state.pageActions.submitForm.pending = state.pageActions.submitForm.pending.filter(
        (id) => id !== action.payload.requestedActionId
      );
      state.pageActions.submitForm.succeeded.push(action.payload.result);
    },
    submitContactFormFailed(state, action: PayloadAction<{ requestedActionId: number }>) {
      state.pageActions.submitForm.pending = state.pageActions.submitForm.pending.filter(
        (id) => id !== action.payload.requestedActionId
      );
      state.pageActions.submitForm.failed.push(action.payload.requestedActionId);
    }
  }
});

export const { submitContactFormRequested, submitContactFormSucceeded, submitContactFormFailed } =
  contactSlice.actions;

export default contactSlice.reducer;
